import { styled } from 'styled-components';

const StyledContainer = styled.div`
	position: relative;
	display: flex;
	align-items: center;

	* {
		color: white;
		font-family: 'GT Walsheim Pro';
		font-style: normal;
		font-weight: bold;
		font-size: 14px;
	}
`;

const StyledHint = styled.span<{ $active: boolean }>`
	pointer-events: none;

	&::after {
		display: flex;
		align-items: center;
		position: absolute;
		left: 10px;
		top: 0;
		right: 0;
		bottom: 0;
		content: attr(data-hint);
		color: rgba(255, 255, 255, 0.25);
		user-select: text;

		${({ $active }) =>
			$active &&
			`
			color: rgba(0, 0, 0, 0.50);
		`}
		transition: color 0.25s ease;
	}
`;

const StyledInput = styled.input<{ $active: boolean }>`
	padding: 10px 8px 10px 25px;
	background-color: rgba(255, 255, 255, 0.05);
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 10px;
	pointer-events: all;
	user-select: text;
	text-align: right;

	&:focus {
		outline: none;
	}

	${({ $active }) =>
		$active &&
		`
		color: black;
		background-color: white;
		border-color: black;
	`}
	transition: color 0.25s ease, background-color 0.25s ease, border-color 0.25s ease;
`;

export { StyledContainer, StyledHint, StyledInput };
